import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IFailedEvent, IFailedEventsQueryParams, IQueryResult } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IFailedEvent>, IFailedEventsQueryParams>>(undefined as any);
